import { makeAutoObservable } from 'mobx';

class Common {
  constructor() {
    makeAutoObservable(this);
  }

  rows = [];
  drillDown = null;
  isOpenExport = false;
  isOpenApprove = false;
  fundsSize = 0;
  isViewer = false;
  contentWidth = 1000;
  commentsSidebarWidth = 0;
  drillDownWidth = 500;

  setRows(payload) {
    this.rows = payload;
  }

  setFundsSize(payload) {
    this.fundsSize = payload;
  }

  setDrillDown(payload) {
    this.drillDown = payload;
  }

  setIsOpenExport(payload) {
    this.isOpenExport = payload;
  }

  setIsViewer(payload) {
    this.isViewer = payload;
  }

  setIsOpenApprove(payload) {
    this.isOpenApprove = payload;
  }

  setContentWidth(payload) {
    this.contentWidth = payload;
  }

  setCommentsSidebarWidth(payload) {
    this.commentsSidebarWidth = payload;
  }

  setDrillDownWidth(payload) {
    this.drillDownWidth = payload;
  }
}

const commonStore = new Common();

export default commonStore;
